import { useEffect, useState } from "react";

// FitScreen — hace que la pantalla del cliente se vea con la MISMA proporción
// a CUALQUIER resolución (1080, 4K, o una intermedia rara), sin elegir nada.
//
// Cómo: el contenido se diseña en un lienzo de tamaño de referencia fijo
// (SCREEN_W × SCREEN_H) y se escala con UN transform uniforme para entrar
// completo en la pantalla real (contain), centrado. El fondo va detrás y
// cubre toda la pantalla (las bandas, si la pantalla no es 9:16, muestran el
// mismo fondo → sin costuras).
//
// POR QUE: el logo/íconos/campaña se configuran en px. Sin esto, en una
// pantalla más ancha el logo se ve más chico (toma menos % del ancho) y en
// una más angosta más grande — y el preview del admin no podía coincidir. Con
// el lienzo de referencia, la proporción es idéntica en TODAS las pantallas y
// el preview (que usa el MISMO lienzo) coincide 100%.

export const SCREEN_W = 1080;
export const SCREEN_H = 1920;

export function FitScreen({
  bgStyle,
  children,
}: {
  bgStyle?: React.CSSProperties;
  children: React.ReactNode;
}) {
  const [vp, setVp] = useState(() => ({
    w: typeof window !== "undefined" ? window.innerWidth : SCREEN_W,
    h: typeof window !== "undefined" ? window.innerHeight : SCREEN_H,
  }));
  useEffect(() => {
    function onResize() {
      setVp({ w: window.innerWidth, h: window.innerHeight });
    }
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  // contain: el lienzo entra completo (sin recortar). En una pantalla 9:16
  // llena exacto; en otra proporción quedan bandas con el fondo de atrás.
  const scale = Math.min(vp.w / SCREEN_W, vp.h / SCREEN_H);

  return (
    <div
      className="app-mode"
      style={{ ...bgStyle, position: "fixed", inset: 0, overflow: "hidden" }}
    >
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          width: SCREEN_W,
          height: SCREEN_H,
          transform: `translate(-50%, -50%) scale(${scale})`,
        }}
      >
        {children}
      </div>
    </div>
  );
}
